import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;
export default {
    stylePath: environment === LOCAL ? `/public/img/imgToImgStyle/` : `/app/ai-tools/img/imgToImgStyle/`,
    originalImageKey: 'ai/input/img2img/',
    resultImageKey: 'ai/export/img2img/',
    historyListType: 3,
    freeLimitType: 'img-to-img',
    currentMenuName: 'ai-image-to-image',
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/imgToImg/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imgToImg/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/imgToImg/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imgToImg/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
    animateImageModalVideoUrl:
        environment === LOCAL
            ? `/public/img/imgToImg/animate-image.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imgToImg/animate-image.mp4?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxTitle: 'transform-your-photos-into-ai-artworks',
    notImageBoxDesc: 'explore-diverse-artistic-styles-and-generate-ai-images-from-your-photos',
};
